/* 🤖 this file was generated by svg-to-ts */
export const sbIconsFuture: {
  name: 'future';
  data: string;
} = {
  name: 'future',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" d="M10 0a10 10 0 0 1 6.88 2.77V1a1 1 0 0 1 2 0v4.5a1 1 0 0 1-1 1h-4.5a1 1 0 0 1 0-2h2.4A8 8 0 1 0 18 10a1 1 0 0 1 2 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0m0 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-1V7a1 1 0 0 0-1-1"/></svg>`
};
